module.exports = __webpack_public_path__ + "static/media/screenshot@4x.0c91c971.png";